import { state } from 'cerebral'
import schemaSettings from '../../../shared/schemas/location-device-schema'
const { locationDeviceSchema: schema } = schemaSettings
import apiClient from '../../lib/util/api-client'
import { createCrudState, redirectUnauthorized } from '../factories'
import { showFeedbackFromError } from '../feedback/factories'
import { createProviders } from '../providers'
import * as sequences from './sequences'

const service = apiClient.service('location-devices')

export default ({ name }) => ({
  state: {
    ...createCrudState({ entityType: 'locationDevices', storePrefix: name }),
  },
  sequences,
  providers: createProviders({ name, service, schema }),
  catch: [
    redirectUnauthorized(),
    [
      Error,
      showFeedbackFromError({ title: 'We encountered an error' }),
      ({ props: { error, errorPath = name }, store }) => {
        store.set(state`errors.${errorPath}`, error)
      },
    ],
  ],
})
